import { AuthorizationError } from '../types/AuthorizationError';
import { requestPost } from '../utils/request';

const BASE_AUTHORIZE_URL = 'https://climate.com/api';
const OIDC_AUTHORIZE_URL = '/oidc/authorize';
// TODO: ADO-50399 - Temporary client id. We have to update this with the web one.
const DEFAULT_CLIENT_ID = 'tccandroid-no-client-credentials';
const DEFAULT_RESPONSE_TYPE = 'code';
const DEFAULT_REDIRECT_URI = 'https://climate.com';
const DEFAULT_SCOPE = 'user';

// TODO: ADO-50396 - Implement PKCE flow when it's ready.
export const authorizeWithPassword = async (
  email: string,
  password: string,
) => {
  const formData = new URLSearchParams();
  formData.append('client_id', DEFAULT_CLIENT_ID);
  formData.append('response_type', DEFAULT_RESPONSE_TYPE);
  formData.append('redirect_uri', DEFAULT_REDIRECT_URI);
  formData.append('scope', DEFAULT_SCOPE);
  formData.append('username', email);
  formData.append('password', password);

  const response = await requestPost(BASE_AUTHORIZE_URL + OIDC_AUTHORIZE_URL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData.toString(),
  });

  if (!response.ok) {
    throw new AuthorizationError(response.status, response.statusText);
  }

  return response.json();
};
